<template>
  <div
    v-if="openPopup"
    class="add-offer-popup"
  >
    <UiConfirm
      ref="confirm"
      :width="480"
      :type="confirm.type"
      :action-name="confirm.actionName"
      :close-action-name="confirm.closeActionName"
      :action="confirm.action"
      :data="confirm.data"
      :action-icon="confirm.actionIcon"
      @save="actionConfirm"
    >
      <template v-slot:title>
        <div>
          {{ confirm.title }}
        </div>
      </template>

      <div class="body__wrap">
        <i
          :class="confirm.type"
          class="fas fa-exclamation-triangle t:mr-12"
        />
        <div
          class="body__msg"
          v-html="confirm.msg"
        />
      </div>
    </UiConfirm>
    <div
      v-loading="isOfferProcessing"
      class="popup"
    >
      <div class="head">
        <span class="name">
          {{ $t(`affiliates.offer_popup.${action}`) }} {{ $t(`affiliates.offer_popup.offer`) }}</span>
        <UiIcon
          :size="19"
          class="close"
          name="times"
          @click="confirmClosePopup"
        />
      </div>
      <div
        class="form"
      >
        <div class="add-offer-popup__left">
          <div
            class="title-wrap"
            :class="{ 'title-wrap-separator': !isCategory }"
          >
            <h2 class="title">
              {{ $t(`affiliates.offer_popup.general`) }}
            </h2>
            <template v-if="!isCategory">
              <UiButton
                v-if="offerData.cataloged_affiliate_offer_id && isEditOfferCustom"
                icon="pen"
                @click="handleEdit"
              >
                {{ $t('crm.buttons.edit') }}
              </UiButton>
              <div
                v-else-if="!offerData.cataloged_affiliate_offer_id && isEditOfferCatalog && offersCatalog.length"
                class="catalog-offer-select__trigger"
              >
                <UiButton
                  @click="toggleCatalogSelect"
                >
                  <div class="catalog-offer-select__header">
                    <UiIcon
                      name="list"
                      color="#212529"
                    />
                    <span>{{ $t('affiliates.affiliatesOffers.switch_to_catalog') }}</span>
                    <i
                      v-if="offersCatalog.length > 1 && isCatalogOfferSelectOpen"
                      class="ui-chevron far fa-angle-up chevron"
                    />
                    <i
                      v-if="offersCatalog.length > 1 && !isCatalogOfferSelectOpen"
                      class="ui-chevron far fa-angle-down chevron"
                    />
                  </div>
                </UiButton>
                <UiSelectElement
                  ref="catalogOfferSelect"
                  filterable
                  class="catalog-offer-select__hidden"
                  @update:model-value="handleCatalogSelect"
                  @visible-change="handleCatalogVisibleChange"
                >
                  <template v-slot:options>
                    <ElOptionGroup
                      v-for="category in offersCatalogGrouped"
                      :key="category.category_id"
                      class="filter-select-group"
                      :label="category.category_name"
                    >
                      <ElOption
                        v-for="offer in category.offers"
                        :key="offer.id"
                        :label="offer.name"
                        :value="offer.id"
                        @click="switchToCatalog(offer)"
                      />
                    </ElOptionGroup>
                  </template>
                </UiSelectElement>
              </div>
            </template>
          </div>
          <UiSelectElement
            v-if="isCategory"
            ref="offerSelect"
            v-model="offerData.category_id"
            class="t:mb-16"
            :placeholder="$t('affiliates.offer_popup.offer_category')"
            :label="$t('affiliates.offer_popup.offer_category')"
            :list="dataCategories"
            size="big"
            filterable
            :error="getError('category_id')"
          />
          <div
            v-if="offerData.cataloged_affiliate_offer_id && offersCatalog.length"
            class="offer-select"
          >
            <UiSelectElement
              v-model="offerData.cataloged_affiliate_offer_id"
              filterable
              :label="$t('affiliates.offer_popup.select_offer')"
              :placeholder="$t('crm.segments.filters.select_rule_placeholder')"
              class="select"
              @change="handleSelectOffer"
            >
              <template v-slot:options>
                <ElOptionGroup
                  v-for="catalog in offersCatalogGrouped"
                  :key="catalog.category_id"
                  class="filter-select-group"
                  :label="catalog.category_name"
                >
                  <ElOption
                    v-for="item in catalog.offers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                  />
                </ElOptionGroup>
              </template>
            </UiSelectElement>
          </div>
          <UiInput
            v-else
            v-model="offerData.name"
            :placeholder="$t('affiliates.offer_popup.offer_placeholder')"
            :label="$t(`affiliates.offer_popup.offer_label`)"
            size="big"
            :error="getError('name')"
            class="offer-input offer-input-name t:mt-8"
          />
          <UiTextarea
            v-if="isCategory"
            v-model="offerData.description"
            class="t:mb-16"
            label-bold
            :label-size="16"
            :label="$t('affiliates.offer_popup.offer_description')"
            :placeholder="$t('affiliates.offer_popup.offer_description')"
            :rows="3"
            :error="errors.description"
          />
          <div
            v-if="offerData.cataloged_affiliate_offer_id && offerData.description"
            class="add-offer-popup__offer-description"
          >
            <span class="label">{{ $t('affiliates.offer_popup.offer_description') }}</span>
            <p>
              {{ offerData.description }}
            </p>
          </div>
          <div
            v-if="offerData.cataloged_affiliate_offer_id"
            class="add-offer-popup__offer-brands"
          >
            <div class="add-offer-popup__offer-brands-label">
              {{ $t('affiliates.affiliatesOffers.available_brands') }}
            </div>
            <div class="add-offer-popup__offer-brands-options">
              <div
                v-for="item in availableBrands(offerData.brand_visibility, offerData.visible_brands_options)"
                :key="item.id"
                class="add-offer-popup__offer-brands-item"
              >
                <img
                  v-if="item.favicon_base64"
                  :src="item.favicon_base64"
                  :alt="item.name"
                  class="add-offer-popup__offer-brands-item-icon"
                >
                <span class="add-offer-popup__offer-brands-item-name">{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div
            v-else
            class="brands-wrap"
          >
            <div class="title-wrap">
              <h2 class="title">
                {{ $t(`affiliates.offer_popup.brands`) }}
              </h2>
            </div>
            <div class="card-filter__body">
              <div class="card-filter__radio-wrap">
                <UiRadioGroup
                  v-model="offerData.brand_visibility"
                  :options="[
                    {
                      label: $t(`affiliates.offer_popup.brands_all`),
                      value: 'all',
                    },
                    {
                      label: $t(`affiliates.offer_popup.brands_only_selected`),
                      value: 'only_selected',
                    }
                  ]"
                  @change="checkBrands(offerData.brand_visibility)"
                >
                  <UiSelectElement
                    v-model="offerData.visible_brands"
                    :placeholder="$t(`affiliates.offer_popup.add_brands`)"
                    :list="brands"
                    size="big"
                    multiple
                    collapse-tag-tooltip
                    :max-collapse-tags="2"
                    :disabled="offerData.brand_visibility === 'all'"
                    :error="errors.visible_brands"
                  />
                </UiRadioGroup>
              </div>
            </div>
          </div>
          <div class="offer-rules">
            <div class="title-wrap">
              <h2 class="title">
                {{ $t(`affiliates.offer_popup.rules`) }}
              </h2>
              <span class="title-order" />
            </div>
            <UiButton
              v-if="!offerData.cataloged_affiliate_offer_id"
              class="offer-rules__btn"
              icon="plus"
              @click="addRule"
            >
              {{ $t(`affiliates.offer_popup.add_rules`) }}
            </UiButton>
            <div class="offer-rules__tabs-wrap">
              <Draggable
                v-model="offerData.payout_rules"
                :disabled="disabledDraggable"
                draggable=".rules-drag:not(.exclude)"
                @start="startDraggable"
                @end="endDraggable"
                @change="draggable"
              >
                <div
                  v-for="(item, index) in offerData.payout_rules"
                  :key="index"
                  :class="{
                    'exclude': index === defaultIndex,
                    'offer-rules__tab--active': indexRule === index && hideRightBlock,
                    'offer-rules__tab--error': errorsRules.length !== 0 && errorsRules[index] !== null,
                  }"
                  class="offer-rules__tab rules-drag"
                  @click="indexRule = index;"
                >
                  <span class="offer-rules__tab-text">
                    <UiIcon
                      size="16px"
                      name="grip-lines"
                      :class="{'exclude': index === defaultIndex}"
                      color="#a6b2c4"
                    />
                    {{ getOfferName(index, 39) }}
                  </span>
                  <div
                    v-if="!offerData.cataloged_affiliate_offer_id"
                    class="offer-rules__icon-right-wr"
                  >
                    <UiIcon
                      substyle="far"
                      name="clone"
                      color="var(--text-primary)"
                      @click.stop="copyRule(index)"
                    />
                    <UiIcon
                      size="14px"
                      class="remove-rule"
                      :class="{ disabled: index === defaultIndex}"
                      name="times"
                      color="var(--text-negative)"
                      @click.stop="confirmRule(index)"
                    />
                  </div>
                </div>
              </Draggable>
            </div>
          </div>
        </div>

        <div
          v-loading="!hideRightBlock"
          class="add-offer-popup__right"
        >
          <div
            v-if="offerData.cataloged_affiliate_offer_id"
            class="filters-and-rules-wrapper"
          >
            <div
              ref="offer-container"
              class="title-wrap add-offer-popup__offer-container"
            >
              <h2 class="title">
                {{ offerName }}
              </h2>
            </div>
            <OfferRulesContent
              :rules-list="offerData.payout_rules"
              :is-active-rule="indexRule"
              :offer-info="offerData"
            />
          </div>
          <div
            v-else
            class="filters-and-rules-wrapper"
          >
            <div
              ref="offer-container"
              class="title-wrap add-offer-popup__offer-container"
            >
              <h2 class="title">
                {{ offerName }}
              </h2>
            </div>
            <!-- filters -->
            <div
              v-if="defaultIndex !== indexRule && hideRightBlock"
              class="filters-block"
            >
              <div class="title-wrap">
                <h2 class="title">
                  {{ $t(`affiliates.offer_popup.filters`) }}
                </h2>
              </div>
              <!-- card  country-->
              <div
                :class="{'card-filter--error': errorFilter(indexRule).indexOf('country_code') !== -1}"
                class="card-filter country-card country_code"
              >
                <div class="card-filter__header">
                  <h2 class="card-filter__title">
                    {{ $t(`affiliates.offer_popup.country`) }}
                  </h2>
                </div>
                <div class="card-filter__body">
                  <div class="card-filter__input-wr">
                    <UiSelectElement
                      :key="indexRule"
                      v-model="offerData.payout_rules[indexRule].filters.country_code"
                      :placeholder="$t(`affiliates.offer_popup.add_country`)"
                      :list="countries"
                      size="big"
                      option-value-param="code"
                      multiple
                      filterable
                      search-param="name"
                      collapse-tag-tooltip
                      popper-class="add-offer-popup__select-country"
                      :max-collapse-tags="5"
                      @change="onTagsUpdated"
                    />
                  </div>
                  <div class="card-filter__tags-wrap">
                    <span
                      v-for="(item, index) in tags"
                      :key="index"
                      :class="{'card-filter__tag--active': tagActive === index}"
                      class="card-filter__tag"
                      @click="countryTag(item, index)"
                    >{{ item.name }}</span>
                  </div>
                </div>
                <UiHelp
                  v-if="errorFilter(indexRule).indexOf('country_code') !== -1"
                  :text="countryError"
                  is-error
                />
              </div>
            </div>
            <RevShare
              :payout-rule="offerData.payout_rules[indexRule]"
              :error-rules="$_.get(errorsRules, indexRule, {})"
              :index-rule="indexRule"
              :action="action"
            />
            <Cpa
              :payout-rule="offerData.payout_rules[indexRule]"
              :error-rules="$_.get(errorsRules, indexRule, {})"
              :currency="currency"
              :index-rule="indexRule"
              :customer-currencies="customerCurrencies"
            />
          </div>
        </div>
      </div>
      <div class="foot t:space-x-8">
        <UiButton
          type="negative"
          icon="times"
          @click="confirmClosePopup"
        >
          {{ $t(`affiliates.offer_popup.cancel`) }}
        </UiButton>
        <div class="add-offer-popup__schedule">
          <UiButton
            :class="{ 'add-offer-popup__schedule-button': action === 'Edit' && !isCategory }"
            filled
            icon="check"
            @click="save"
          >
            {{ action === 'Add' || isCategory ? $t(`affiliates.offer_popup.apply`) : $t(`affiliates.offer_popup.apply_now`) }}
          </UiButton>
          <ElPopover
            v-if="action === 'Edit' && !isCategory"
            v-model:visible="effDatePopover"
            :transition="null"
            popper-class="eff-date"
            placement="top-end"
            width="250"
            trigger="click"
          >
            <template v-slot:reference>
              <span>
                <UiIcon
                  color="#ffffff"
                  name="calendar-days"
                />
              </span>
            </template>

            <div v-loading="isOfferProcessing">
              <div class="field">
                <UiDatePicker
                  v-model="date"
                  :label="$t(`affiliates.offer_popup.eff_date_time`)"
                  :placeholder="$t(`tools.match_popup.placeholder_date_time`)"
                  :multi-calendars="false"
                  :range="false"
                  :always-clearable="false"
                  :offset="34"
                  auto-position="top"
                  external-format="dd MMM yyyy HH:mm"
                  enable-time-picker
                  :error="errors.effective_timestamp"
                  size="big"
                />
              </div>
              <div class="field eff-date__timezone">
                <UiSelectElement
                  v-model="utc"
                  :label="$t(`tools.match_popup.timezone`)"
                  :placeholder="$t(`tools.match_popup.placeholder_timezone`)"
                  :list="timezones"
                  size="big"
                  option-value-param="zone"
                  filterable
                  :teleported="false"
                />
              </div>
              <div class="field eff-date__btn-wr t:space-x-8">
                <UiButton
                  type="negative"
                  icon="times"
                  @click="effDatePopover = false"
                >
                  {{ $t(`affiliates.offer_popup.cancel`) }}
                </UiButton>
                <UiButton
                  filled
                  icon="check"
                  @click="save('tz'); effDatePopover = false;"
                >
                  {{ $t(`affiliates.offer_popup.schedule_changes`) }}
                </UiButton>
              </div>
            </div>
          </ElPopover>
        </div>
      </div>
    </div>
    <div class="wrapper" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import draggable from 'vuedraggable';
import { VueDraggable as draggable } from 'vue-draggable-plus';
import { format, startOfDay, addDays } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import aclMixin from '@/views/mixins/acl';
import errorHandleMixin from '@/views/mixins/error-hadle';
import offerMixin from '@/views/mixins/offer';
import RevShare from './RevShare.vue';
import Cpa from './Cpa/Cpa.vue';
import OfferRulesContent from '../OfferRulesContent.vue';


export default {
  name: 'AddOfferPopup',
  components: {
    Draggable: draggable,
    RevShare,
    Cpa,
    OfferRulesContent,
  },
  mixins: [aclMixin, errorHandleMixin, offerMixin],
  props: {
    action: {
      type: String,
      default: 'Add',
    },
    currency: {
      type: String,
      default: '',
    },
    customerCurrencies: {
      type: Array,
      default: () => [],
    },
    offersCatalog: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    isCategory: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
    permissions: {
      type: Object,
      default: () => ({}),
    },
    offerPermissions: {
      type: Object,
      default: () => ({}),
    },
    affiliate: {
      type: String,
      default: null,
    },
  },
  emits: ['close', 'refresh'],
  data() {
    return {
      isOpenPicker: false,
      isCatalogOfferSelectOpen: false,
      effDatePopover: false,
      date: null,
      utc: 'GMT',
      edited: false,
      unwatch: Function,
      disabledDraggable: false,
      isOfferProcessing: false,
      hideRightBlock: true,
      hideRightBlockNext: true,
      tagActive: -1,
      tags: [],
      dataCategories: [],
      listFilter: [],
      openFilter: [],
      openPopup: false,
      indexRule: 0,
      offerData: {},
      dataDefault: {
        affiliate_id: '',
        name: '',
        global_cap_period_seconds: 0,
        global_cap_players_count: 0,
        global_hold_seconds_rev_share: null,
        global_hold_seconds_cpa: null,
        payout_rules: [
          {
            settings: {
              rev_share: {
                sport_levels: [
                  {
                    percent: 0,
                    ftd_count: 0,
                  },
                ],
                casino_levels: null,
                // casino_levels: [
                //   {
                //     percent: 0,
                //     ftd_count: 0,
                //   },
                // ],
              },
              cpa: null,
            },
            filters: {
              country_code: [],
            },
          },
        ],
        brand_visibility: 'all',
      },
      errors: {},
      errorsRules: [],
      hideBlockFilter: true,
      arrOldGDC: [],
      confirm: {
        title: '',
        msg: '',
        type: 'success',
        actionIcon: 'check',
        action: '',
        actionName: '',
        data: {},
      },
    };
  },
  computed: {
    ...mapGetters({
      countries: 'misc/countries',
      timezones: 'misc/timezones',
      brands: 'misc/brands',
    }),

    isEditOfferCustom() {
      if (this.action === 'Edit') {
        return this.offerPermissions.edit_custom;
      }

      return this.permissions.edit_offers_custom;
    },

    isEditOfferCatalog() {
      if (this.action === 'Edit') {
        return this.offerPermissions.edit_linked_to_catalog;
      }

      return this.permissions.edit_offers_linked_to_catalog;
    },
    offersCatalogCategory() {
      return this.$_.uniqBy([
        ...this.offersCatalog,
        ...(this.data.category_id ? [{
          category_id: this.data.category_id,
          category_name: this.data.category_name,
          id: this.data.cataloged_affiliate_offer_id,
          name: this.data.name,
          disabled: true,
        }] : []),
      ], 'id');
    },
    offersCatalogGrouped() {
      return Object.values(this.offersCatalogCategory.reduce((acc, offer) => {
        const categoryId = offer.category_id;
        const categoryName = offer.category_name;

        if (!acc[categoryId]) {
          acc[categoryId] = {
            category_id: categoryId,
            category_name: categoryName,
            offers: [],
          };
        }
        acc[categoryId].offers.push(offer);
        return acc;
      }, {}));
    },
    countryError() {
      const error = this.errorsRules[this.indexRule].filters.country_code.filter((el) => !!el);
      if (this.$_.get(error, [0, 'message'])) {
        return this.$_.get(error, [0, 'message']);
      }

      return this.$_.get(error, [0, 0, 'message'], '');
    },
    defaultIndex() {
      return this.offerData.payout_rules.length - 1;
    },
    offerName() {
      return this.getOfferName(this.indexRule, 75);
    },
    profile() {
      return this.$store.getters['auth/adminInfo'];
    },
    realDate() {
      return format(this.date, 'yyyy-MM-dd HH:mm:ss');
    },
  },
  watch: {
    isCatalogOfferSelectOpen(value) {
      const selectRef = this.$refs?.catalogOfferSelect?.$refs?.uiSelectElement;

      if (!selectRef) {
        return;
      }

      if (value) {
        selectRef.toggleMenu();
      } else {
        selectRef.blur();
      }
    },
    /* вочер который блокирует скрытее поповера, если открыт датапикер */
    // effDatePopover(v) {
    //   console.log(v);
    //   if (!v) {
    //     this.$nextTick(() => {
    //       this.effDatePopover = true;
    //     });
    //   }
    // },
    indexRule(v) {
      this.timeoutMethod();
      this.getKeyFilter(v);
      this.$nextTick(() => {
        this.errorsRules = this.$_.cloneDeep(this.errorsRules);
      });
      this.tagActive = -1;
      this.selectTagCountry(v);
    },
    async isOpen(v) {
      // open
      if (v === true) {
        const response = await this.$api.getAffiliateOffersCatalogCategories();
        this.dataCategories = this.$_.cloneDeep(response.data.payload);

        document.querySelector('#app').classList.add('offer-ovf');
        this.edited = false;
        this.disabledDraggable = false;

        this.offerData = this.$_.cloneDeep({
          ...this.data,
          payout_rules: this.data.payout_rules.map((elem, i) => {
            const defaultCpa = [{
              amount: 0,
              currency_code: this.currency,
              cap_period_seconds: 0,
              cap_players_count: 0,
              hold_seconds: 0,
            }];

            const defaultRs = {
              sport_levels: [
                {
                  percent: 0,
                  ftd_count: 0,
                },
              ],
              casino_levels: null,
            };

            return {
              ...elem,
              settings: {
                ...elem.settings,
                cpa: elem?.settings?.cpa || (!this.ableToSetRevShare && defaultCpa) || null,
                rev_share: elem?.settings?.rev_share || (!this.ableToSetCpa && defaultRs) || null,
                name: this.data.payout_rules.length - 1 === i ? 'Default' : '',
              },
            };
          }),
        });

        this.offerData.visible_brands_options = this.$_.cloneDeep(this.offerData.visible_brands);
        this.offerData.visible_brands = this.getVisibleBrands();
        this.arrOldGDC.push(this.offerData.global_daily_cap);
        this.indexRule = 0;

        this.getKeyFilter(this.indexRule);

        if (this.action === 'Add') {
          const countPayoutRule = this.offerData.payout_rules.length || 1;
          this.errorsRules = new Array(countPayoutRule).fill(null);
        }
        if (this.action === 'Edit') {
          this.selectTagCountry(this.indexRule);
        }

        this.$nextTick(() => {
          const editedStart = this.$_.cloneDeep(this.offerData);
          this.unwatch = this.$watch('offerData', (nv) => {
            this.edited = !this.$_.isEqual(editedStart, nv);
          }, { deep: true });
        });

        this.utc = this.profile.timezone;
        this.date = startOfDay(addDays(new Date(), 1));
      }
      // close
      if (v === false) {
        document.querySelector('#app').classList.remove('offer-ovf');

        this.disabledDraggable = false;
        this.errorsRules = [];
        this.arrOldGDC = [];
        this.errors = {};
        this.unwatch();
      }
      this.openPopup = v;
    },
  },
  async mounted() {
    const { data: { payload } } = await this.$api.getCountryTags();
    this.tags = payload;
    this.errors = {};
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close('confirm');
      }
    });
    // filters-and-rules-wrapper
  },
  methods: {
    toggleCatalogSelect() {
      this.isCatalogOfferSelectOpen = !this.isCatalogOfferSelectOpen;
    },
    handleCatalogVisibleChange(value) {
      this.isCatalogOfferSelectOpen = value;
    },
    handleCatalogSelect(value) {
      const offer = this.offersCatalog.find((item) => item.id === value);
      if (offer) {
        this.switchToCatalog(offer);
      }
    },
    handleSelectOffer(id) {
      const offer = this.offersCatalog.find((el) => el.id === id);
      this.switchToCatalog(offer);
    },
    availableBrands(visibility, offerBrands) {
      if (visibility !== 'all') {
        const formatedBrands = [];
        offerBrands.forEach((brand) => {
          formatedBrands.push({
            id: brand.site_id,
            name: brand.site_name,
            favicon_base64: brand.site_favicon,
          });
        });
        return formatedBrands;
      }
      return this.brands;
    },
    handleEdit() {
      this.offerData.cataloged_affiliate_offer_id = null;
    },
    switchToCatalog(offer) {
      this.isCatalogOfferSelectOpen = false;
      this.indexRule = 0;
      this.errorsRules = [];
      this.errors = {};

      this.offerData = this.$_.cloneDeep({
        ...offer,
        payout_rules: offer.payout_rules.map((r) => ({
          ...r,
          settings: {
            ...r.settings,
            rev_share: r.settings.rev_share ? {
              sport_levels: r.settings.rev_share.sport_levels,
              casino_levels: this.$_.isEqual(r.settings.rev_share.sport_levels, r.settings.rev_share.casino_levels)
                ? null : r.settings.rev_share.casino_levels,
            } : null,
            cpa: r.settings?.cpa?.map((cpa) => ({
              currency_code: this.currency,
              ...cpa,
            }))?.map(this.genCpaParams) || null,
          },
        })),
        cataloged_affiliate_offer_id: offer.id,
      });

      this.offerData.visible_brands_options = this.$_.cloneDeep(this.offerData.visible_brands);
      this.offerData.visible_brands = this.getVisibleBrands();
    },
    insertByIndex(arr, index, item) {
      const cloned = this.$_.cloneDeep(arr);
      cloned.splice(index, 0, this.$_.cloneDeep(item));
      return cloned;
    },
    countryPartName(index, rowLen) {
      const prefix = this.prefixName(index);
      const values = this.offerData.payout_rules[index].filters?.country_code || [];

      if (!values?.length) {
        return prefix;
      }

      if (rowLen === null) {
        return values.join(', ');
      }

      const fitValues = this.$_.truncate(values.join(', '), {
        length: rowLen - prefix.length,
        separator: ', ',
        omission: '',
      });

      const notFit = values.filter((val) => !fitValues.split(', ').includes(val));
      const countNotFit = notFit.length ? ` [+${notFit.length}]` : '';
      return `${prefix} ${fitValues}${countNotFit}`;
    },
    isEmptyRs(lvl) {
      if (!lvl || this.$_.isEmpty(lvl)) return true;

      return lvl.every((el) => !+el.percent);
    },
    prefixName(index) {
      const { rev_share, cpa } = this.offerData.payout_rules[index].settings;

      if (
        [rev_share?.sport_levels, rev_share?.casino_levels].every(this.isEmptyRs)
        && cpa
        && cpa.some((el) => el.amount > 0)
      ) {
        return '[CPA] ';
      }

      if (rev_share && cpa) {
        return '[Hyb] ';
      }

      if (rev_share) {
        return '[RS] ';
      }

      if (cpa) {
        return '[CPA] ';
      }

      return '';
    },
    getOfferName(index, rowLen) {
      if (index === this.defaultIndex) {
        return 'Default';
      }

      return this.countryPartName(index, rowLen);
    },

    checkBrands(value) {
      this.errors = {};
      if (value === 'all') {
        this.offerData.visible_brands = null;
      }
    },
    getVisibleBrands() {
      return this.$_.map(this.offerData.visible_brands, 'site_id');
    },
    toScroll(elem) {
      setTimeout(() => {
        const el = this.$el.getElementsByClassName(elem)[0];
        const wrap = this.$el.getElementsByClassName('filters-and-rules-wrapper')[0];
        wrap.scrollTop = el.offsetTop - wrap.offsetTop;
      });
    },
    afterDeleteFirstRule(v) {
      this.timeoutMethod();
      this.getKeyFilter(v);
      this.$nextTick(() => {
        this.errorsRules = this.$_.cloneDeep(this.errorsRules);
      });
      this.tagActive = -1;
      this.selectTagCountry(v);
    },

    confirmRule(index) {
      if ((index === 0 && this.offerData.payout_rules.length === 1) || index === this.defaultIndex) return;
      this.confirm.title = this.$t('affiliates.offer_popup.confirm_rule.title');
      this.confirm.msg = this.$t('affiliates.offer_popup.confirm_rule.msg');
      this.confirm.type = 'warning';
      this.confirm.action = 'rule';
      this.confirm.actionName = this.$t('affiliates.offer_popup.confirm_rule.action');
      this.confirm.closeActionName = '';
      this.confirm.data = index;
      this.$refs.confirm.open();
    },
    confirmClosePopup() {
      if (this.edited) {
        this.confirm.title = this.$t('affiliates.offer_popup.confirm_close.title');
        this.confirm.msg = this.$t('affiliates.offer_popup.confirm_close.msg');
        this.confirm.type = 'warning';
        this.confirm.action = 'close';
        this.confirm.actionName = this.$t('affiliates.offer_popup.confirm_close.action');
        this.confirm.closeActionName = this.$t('affiliates.offer_popup.confirm_close.closeAction');
        this.confirm.data = '';
        this.$refs.confirm.open();
      } else {
        this.$refs.confirm.close();
        this.close();
      }
    },
    actionConfirm(action, v) {
      switch (action) {
      case 'rule':
        this.deleteRule(v);
        this.$refs.confirm.close();
        break;
      case 'filter':
        this.deleteFilter(v, this.indexRule);
        this.$refs.confirm.close();
        break;
      case 'close':
        this.$refs.confirm.close();
        this.close();
        break;
      default:
        break;
      }
    },
    timeoutMethod() {
      this.hideBlockFilter = false;
      setTimeout(() => {
        this.hideBlockFilter = true;
      }, 50);
    },
    errorFilter(index) {
      if (this.errors.hasOwnProperty('payout_rules')) {
        if (this.errors.payout_rules[index] === null || this.errors.payout_rules[index] === undefined) return [];
        if (this.errors.payout_rules[index].hasOwnProperty('filters')) {
          return this.$_.keys(this.errors.payout_rules[index].filters);
        }
      }
      return [];
    },
    makeErrArray() {
      const errLength = this.errorsRules.length;
      const ruleLength = this.offerData.payout_rules.length;
      if (errLength < ruleLength) {
        for (let i = 0; i < ruleLength - errLength; i += 1) {
          this.errorsRules.push(null);
        }
      }
    },
    startDraggable() {
      this.hideRightBlock = false;
      this.hideRightBlockNext = false;
    },
    draggable(added) {
      //this.indexRule = added.moved.oldIndex;
    },
    endDraggable() {
      setTimeout(() => {
        this.hideRightBlock = true;
        //this.indexRule = e.newIndex;
      }, 100);
    },
    selectTagCountry(/* index */) {
      setTimeout(() => {
        this.tags.forEach((el, i) => {
          if (this.$_.has(this.offerData.payout_rules[this.indexRule].filters, 'country_code') && this.$_.isEqual(
            this.$_.sortBy(el),
            this.$_.sortBy(this.offerData.payout_rules[this.indexRule].filters.country_code),
          )) {
            this.tagActive = i;
          }
        });
      }, 51);
    },
    onTagsUpdated() {
      if (this.tagActive === -1) return;
      if (this.$_.isEqual(
        this.$_.sortBy(this.tags[this.tagActive].values),
        this.$_.sortBy(this.offerData.payout_rules[this.indexRule].filters.country_code),
      )) {
        return;
      }

      this.tagActive = -1;
    },
    countryTag(item, index) {
      if (this.tagActive !== index) {
        this.tagActive = index;
        this.offerData.payout_rules[this.indexRule].filters.country_code = [];
        this.offerData.payout_rules[this.indexRule].filters.country_code = item.values;
      } else {
        this.tagActive = -1;
        this.offerData.payout_rules[this.indexRule].filters.country_code = [];
      }
    },
    deleteFilter(v, index) {
      delete this.offerData.payout_rules[index].filters[v];
      this.getKeyFilter(this.indexRule);
    },
    getKeyFilter(index) {
      let listFilter = [];
      const defaultFiltersName = ['country_code'];
      listFilter = this.$_.keys(this.offerData.payout_rules[index].filters);
      listFilter.forEach((e) => {
        if (defaultFiltersName.indexOf(e) !== -1) {
          defaultFiltersName.splice(defaultFiltersName.indexOf(e), 1);
        }
      });
      this.openFilter = listFilter;
      this.listFilter = defaultFiltersName;
    },
    addRule() {
      const insertIndex = (this.defaultIndex) || 0;
      const defaultRule = {
        ...this.dataDefault.payout_rules[0],
        settings: {
          ...this.dataDefault.payout_rules[0].settings,
          cpa: this.ableToSetCpa && !this.ableToSetRevShare ? [{
            amount: 0,
            currency_code: this.currency,
            cap_players_count: null,
            cap_period_seconds: null,
            hold_seconds: 0,
          }] : null,
        },
      };

      if (this.action === 'Add') {
        this.offerData.payout_rules = this.insertByIndex(this.offerData.payout_rules, insertIndex, defaultRule);
        this.errorsRules = this.insertByIndex(this.errorsRules, insertIndex, null);
      }
      if (this.action === 'Edit') {
        this.offerData.payout_rules = this.insertByIndex(this.offerData.payout_rules, insertIndex, defaultRule);
      }

      this.indexRule = this.defaultIndex - 1;
    },
    copyRule(index) {
      const insertIndex = (this.defaultIndex) || 0;

      const copiedRule = this.$_.cloneDeep({
        ...this.offerData.payout_rules[index],
        filters: {
          country_code: [],
        },
        settings: {
          ...this.offerData.payout_rules[index].settings,
          name: '',
        },
      });

      this.offerData.payout_rules = this.insertByIndex(this.offerData.payout_rules, insertIndex, copiedRule);

      if (this.action === 'Add') {
        this.errorsRules = this.insertByIndex(this.errorsRules, insertIndex, null);
      }

      this.indexRule = this.defaultIndex - 1;
    },
    deleteRule(index) {
      if (index === 0 && this.offerData.payout_rules.length > 1) {
        this.indexRule = index;
        this.openFilter.forEach((v) => {
          this.deleteFilter(v, index);
        });

        this.offerData.payout_rules.splice(index, 1);
        this.errorsRules.splice(index, 1);
        this.afterDeleteFirstRule(index);
      } else {
        this.indexRule = index - 1;
        this.openFilter.forEach((v) => {
          this.deleteFilter(v, index);
        });
        this.offerData.payout_rules.splice(index, 1);
        this.errorsRules.splice(index, 1);
      }
    },
    close(flag, action, isLastAdded = false) {
      if (flag === 'confirm') {
        this.confirmClosePopup();
      } else {
        this.$emit('close', action || this.action, isLastAdded);
      }
    },
    getCpaParams(data) {
      const {
        amount,
        currency_code,
        cap_players_count,
        cap_period_seconds,
        hold_seconds,
        player_activity,
        ...restParams
      } = data;

      const mapValue = {
        _min: 'min_value',
        _max: 'max_value',
      };

      const conditions = Object.entries(restParams).reduce((acc, [key, value]) => {
        const group = key.match(/(_min$|_max$)/g);
        const name = key.replace(group, '');

        if (acc[name]) {
          acc[name] = {
            ...acc[name],
            [mapValue[group]]: value,
          };
        } else {
          acc[name] = {
            name,
            [mapValue[group]]: value,
          };
        }

        return acc;
      }, player_activity ? { player_activity: { name: 'player_activity', ...player_activity } } : {});

      return {
        amount,
        currency_code,
        cap_players_count,
        cap_period_seconds,
        hold_seconds,
        conditions: Object.values(conditions)
          .filter(({ min_value, max_value }) => !(min_value === null && max_value === null)),
      };
    },
    save(act) {
      const q = {
        name: this.offerData.name,
        description: this.offerData.description,
        effective_timestamp: act === 'tz' ? format(fromZonedTime(this.realDate, this.utc), 'yyyy-MM-dd HH:mm:ss') : null,
        ...(!this.isCategory && {
          affiliate_id: this.affiliate,
        }),
        ...(this.offerData.cataloged_affiliate_offer_id && {
          cataloged_affiliate_offer_id: this.offerData.cataloged_affiliate_offer_id,
        }),
        ...(!this.offerData.cataloged_affiliate_offer_id && {
          global_cap_players_count: this.offerData.global_cap_players_count,
          global_cap_period_seconds: this.offerData.global_cap_period_seconds,
          global_hold_seconds_rev_share: this.offerData.global_hold_seconds_rev_share,
          global_hold_seconds_cpa: this.offerData.global_hold_seconds_cpa,
          brand_visibility: this.offerData.brand_visibility,
          visible_brands: this.offerData.visible_brands,
          payout_rules: this.offerData.payout_rules.map((rule) => ({
            ...rule,
            settings: {
              rev_share: this.ableToSetRevShare && rule.settings?.rev_share ? {
                sport_levels: rule.settings.rev_share.sport_levels,
                casino_levels: rule.settings.rev_share.casino_levels || rule.settings.rev_share.sport_levels,
              } : null,
              cpa: (this.ableToSetCpa && rule.settings.cpa?.map(this.getCpaParams)) || null,
            },
          })),
        }),
      };

      let promise;

      switch (this.action) {
      case 'Add':
        this.isOfferProcessing = true;
        this.errors = {};
        this.errorsRules = [];
        promise = this.isCategory
          ? this.$api.postAffiliateOffersCatalog(
              { ...q,
                category_id: this.offerData.category_id,
                distribution_settings: { is_default: true },
              },
            )
          : this.$api.addAffiliateOffer(q);

        promise
          .then(() => {
            this.isOfferProcessing = false;
            this.close(null, 'save', true);
          })
          .catch((error) => {
            this.disabledDraggable = true;
            this.isOfferProcessing = false;
            this.errors = this.$_.cloneDeep(error.data.errors);
            if (this.errors.hasOwnProperty('payout_rules')) {
              this.errorsRules = error.data.errors.payout_rules?.map((rule, indexRule) => {
                if (!rule) return rule;

                return {
                  ...rule,
                  settings: {
                    ...rule.settings,
                    cpa: rule.settings?.cpa?.map((cpa, indexCpa) => ({
                      ...cpa,
                      conditions: cpa?.conditions?.reduce((acc, condition, indexCondition) => {
                        if (condition?.code === 1000) {
                          return [condition];
                        }
                        if (condition) {
                          const key = this.$_.get(q, ['payout_rules', indexRule, 'settings', 'cpa', indexCpa, 'conditions', indexCondition, 'name']);

                          if (key) {
                            acc[key] = condition;
                          }
                        }

                        return acc;
                      }, {}) || null,
                    })) || null,
                  },
                };
              });
              this.makeErrArray();
            }
          }).finally(() => this.$emit('refresh'));
        break;
      case 'Edit':
        this.isOfferProcessing = true;
        this.errors = {};
        this.errorsRules = [];
        promise = this.isCategory
          ? this.$api.putAffiliateOffersCatalog(
              this.data.id,
              {
                ...q,
                category_id: this.offerData.category_id,
                distribution_settings: { is_default: true },
              },
            )
          : this.$api.putAffiliateOffer(this.data.id, q);

        promise
          .then(() => {
            this.isOfferProcessing = false;
            this.close();
          })
          .catch((error) => {
            this.disabledDraggable = true;
            this.isOfferProcessing = false;
            this.errors = this.$_.cloneDeep(error.data.errors);

            if (this.errors.hasOwnProperty('payout_rules')) {
              this.errorsRules = error.data.errors.payout_rules?.map((rule, indexRule) => {
                if (!rule) return rule;

                return {
                  ...rule,
                  settings: {
                    ...rule.settings,
                    cpa: rule.settings?.cpa?.map((cpa, indexCpa) => ({
                      ...cpa,
                      conditions: cpa?.conditions?.reduce((acc, condition, indexCondition) => {
                        if (condition?.code === 1000) {
                          return [condition];
                        }
                        if (condition) {
                          const key = this.$_.get(q, ['payout_rules', indexRule, 'settings', 'cpa', indexCpa, 'conditions', indexCondition, 'name']);

                          if (key) {
                            acc[key] = condition;
                          }
                        }

                        return acc;
                      }, {}) || null,
                    })) || null,
                  },
                };
              });
              this.makeErrArray();
            }
          });
        break;
      default:
        break;
      }
    },
  },
};
</script>

<style lang="scss">
.add-offer-popup {
  &__select-country {
    min-width: auto !important;
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.catalog-offer-select__trigger {
  position: relative;
}

.catalog-offer-select__hidden {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
}

.catalog-offer-select__header {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
}

.remove-rule.disabled, .rules-drag .exclude {
  opacity: .5;
}

.remove-rule.disabled {
  cursor: not-allowed;
}

.add-offer-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 900;

  .field-error {
    text-align: right;
    margin-top: 6px;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 0;
  }

  .blur{
    filter: blur(10px);
  }
  .popup {
    width: 1140px;
    height: 80vh;
    min-height: 320px;
    position: relative;
    z-index: 902;
    border-radius: 8px;
    background-color: white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .filters-and-rules-wrapper {
      overflow-y: auto;
      scrollbar-gutter: stable;
      flex: 1;
      padding-right: 4px;
    }

    .offer-select {
      display: flex;
      flex-direction: column;
    }

    .offer-select, .offer-description {
      margin-bottom: 16px;

      :deep() {
        & > .label {
          font-size: 14px;
          margin-bottom: 5px;
        }

        .el-textarea {
          margin-top: 5px;
        }

        .el-select.error {
          .el-input__inner {
            border-color: var(--text-negative);
          }
        }

        .el-textarea.error {
          textarea {
            border-color: var(--text-negative);
          }
        }
      }
    }

    .title-wrap {
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-separator {
        padding-bottom: 16px;
        border-bottom: solid 1px #dee2e6;
      }

      &.rev-share {
        justify-content: flex-start;
        align-items: flex-end;
      }
    }
    .title {
      font-size: 20px;
      font-weight: 500;
      color: #303634;
    }
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eaeaea;
      padding: 16px 24px;
      .name {
        font-size: 20px;
        font-weight: 500;
      }
      .close {
        color: #303634;
        padding: 5px;
        font-size: 32px;
        cursor: pointer;
      }
    }
    .form {
      padding-left: 24px;
      padding-right: 24px;
      display: flex;
      align-items: stretch;
      height: calc(100% - 124px);
      .offer-input-name{
        margin-bottom: 16px;
        // min-width: 320px;
        width: 100% !important;
      }
      .sub-title{
        font-size: 16px;
        font-weight: 500;
        color: #303634;
      }
      .add-offer-popup__left{
        overflow-y: auto;
        padding-right: 24px;
        padding-top: 16px;
        padding-bottom: 16px;
        border-right: 1px solid #eaeaea;
        width: calc(30% + 24px);

        .wrap-global{
          display: flex;
          align-items: flex-end;
          .offer-input-daily{
            max-width: 144px;
          }
          .offer-input-hold{
            margin-left: 16px;
            max-width: 74px;
          }
          .select{
            margin-left: 8px;
            max-width: 88px;
          }
        }
        .brands-wrap{
          margin-top: 16px;
          .title-wrap{
            margin-bottom: 8px;

            .title {
              font-size: 16px;
            }
          }

          .tags-input-root{
            width: 320px;
            &.disabled {
              opacity: .5;
              cursor: default;
              pointer-events: none;
            }
          }
        }
      }
      .offer-rules{
        padding-top: 16px;
        //height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .title-order{
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: #696969;
          i{
            margin-left: 6px;
          }
        }
        &__btn{
          width: 100%;
          font-size: 12px;
          border-radius: 4px;
          height: 34px;
        }
        &__tabs-wrap{
          margin-top: 8px;
          overflow-y: auto;
          flex: 1;
          width: 100%;
        }
        &__tab{
          padding-left: 8px;
          padding-right: 8px;
          margin-bottom: 8px;
          height: 34px;
          border-radius: 4px;
          background-color: #f4f7fa;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          border: 1px solid #f4f7fa;
          transition: all .3s ease 0s;
          &:hover{
            transition: all .3s ease 0s;
          }
          &--active{
            border: 1px solid #20815e;
          }
          &--error{
            background-color: rgba(255, 72, 6, 0.092);
          }
        }
        &__tab-text{
          display: flex;
          align-items: center;
          font-size: 12px;
          white-space: nowrap;
          i{
            margin-right: 8px;
          }
        }
        &__icon-right-wr {
          display: flex;
          align-items: center;
          .fa-clone{
            margin-right: 16px;
          }
        }

      }
      .add-offer-popup__right{
        width: 734px;
        padding-top: 16px;
        padding-left: 24px;
        display: flex;
        flex-direction: column;
        transition: all .6s ease-out;
      }
    }
    .foot {
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid #eaeaea;
      padding: 16px 24px;
      .add-offer-popup{
        &__schedule{
          display: flex;
          >span {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: var(--background-primary);
            width: 26px;
            border-radius: 0 5px 5px 0;
            border-left: 1px solid  var(--overlay-white-50);
            cursor: pointer;
            i{
              padding-top: 6px;padding-bottom: 6px;
            }
          }
        }
        &__schedule-button {
          border-radius: 5px 0 0 5px;
        }
      }
    }
  }
  .wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    background-color: #303634;
    z-index: 901;
  }
}
</style>
